
export default {
	TIER:   'eventtier',
	SPONSOR:'eventsponsor',
	GENDERMEN: 'eventgendermen',
	GENDERWOMEN: 'eventgenderwomen',
	JVEVENT:'eventjv',
	JVGENDERMEN: 'eventjvgendermen',
	JVGENDERWOMEN: 'eventjvgenderwomen',
	SAMEQUALIFYINGFORMAT: 'eventsamequalifyingformat',
	IS_EVENT_DETAILS_VERIFIED: 'isEventDetailsVerified'
}


// WEBPACK FOOTER //
// ./src/containers/event/EventWizard/EventDetails/fields.js